import React, { useState } from 'react';
import { UsersIcon, Loader2Icon, SparklesIcon, TargetIcon, FrownIcon, ShieldAlertIcon, HeartIcon } from 'lucide-react';
export function AvatarResearch() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2000);
  };
  return <div className="max-w-5xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-109">
      <div data-id="element-110">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-111">
          Investigación de Avatar (ICP)
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-112">
          Descubre exactamente a quién le hablas, sus miedos profundos y qué los
          motiva a comprar.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex items-end gap-6" data-id="element-113">
        <div className="flex-1 space-y-2" data-id="element-114">
          <label className="block text-sm font-medium text-slate-700" data-id="element-115">
            Nicho Gastronómico
          </label>
          <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-116">
            <option data-id="element-117">Repostería desde Casa</option>
            <option data-id="element-118">Street Food / Fast Food</option>
            <option data-id="element-119">Comida Saludable / Keto</option>
            <option data-id="element-120">Catering / Eventos</option>
          </select>
        </div>
        <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 transition-colors h-[42px]" data-id="element-121">
          {isGenerating ? <>
              <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-122" /> Investigando...
            </> : <>
              <SparklesIcon className="w-5 h-5" data-id="element-123" /> Generar Perfil
            </>}
        </button>
      </div>

      {hasGenerated && <div className="grid grid-cols-1 md:grid-cols-2 gap-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-124">
          {/* Profile Card */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 md:col-span-2 flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-125">
            <div className="w-32 h-32 bg-indigo-100 rounded-full flex items-center justify-center shrink-0 border-4 border-indigo-50" data-id="element-126">
              <UsersIcon className="w-12 h-12 text-indigo-500" data-id="element-127" />
            </div>
            <div data-id="element-128">
              <div className="inline-block bg-indigo-100 text-indigo-800 text-xs font-bold px-2.5 py-0.5 rounded-full mb-2" data-id="element-129">
                Perfil Principal
              </div>
              <h2 className="text-2xl font-bold text-slate-900" data-id="element-130">
                "María la Repostera Cansada"
              </h2>
              <p className="text-slate-600 mt-2" data-id="element-131">
                Mujer hispana, 28-45 años. Madre de familia que empezó a vender
                postres para generar ingresos extra sin descuidar a sus hijos.
                Tiene talento culinario pero cero educación financiera o de
                marketing.
              </p>
              <div className="flex gap-4 mt-4" data-id="element-132">
                <span className="text-sm text-slate-500" data-id="element-133">
                  <strong data-id="element-134">Ingresos actuales:</strong> $300 - $800/mes
                </span>
                <span className="text-sm text-slate-500" data-id="element-135">
                  <strong data-id="element-136">Canal principal:</strong> WhatsApp / IG
                </span>
              </div>
            </div>
          </div>

          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-137">
            <h3 className="font-bold text-red-900 flex items-center gap-2 mb-4" data-id="element-138">
              <FrownIcon className="w-5 h-5 text-red-500" data-id="element-139" /> Mapa de Dolor
              Profundo
            </h3>
            <ul className="space-y-3" data-id="element-140">
              <li className="text-sm text-red-800 bg-white p-3 rounded shadow-sm" data-id="element-141">
                Siente culpa por cobrar "caro" a sus conocidos.
              </li>
              <li className="text-sm text-red-800 bg-white p-3 rounded shadow-sm" data-id="element-142">
                Trabaja fines de semana enteros y no ve el dinero.
              </li>
              <li className="text-sm text-red-800 bg-white p-3 rounded shadow-sm" data-id="element-143">
                Su esposo/familia le dice que "mejor busque un trabajo de
                verdad".
              </li>
            </ul>
          </div>

          <div className="bg-amber-50 p-6 rounded-xl border border-amber-100" data-id="element-144">
            <h3 className="font-bold text-amber-900 flex items-center gap-2 mb-4" data-id="element-145">
              <ShieldAlertIcon className="w-5 h-5 text-amber-500" data-id="element-146" /> Objeciones
              de Compra
            </h3>
            <ul className="space-y-3" data-id="element-147">
              <li className="text-sm text-amber-800 bg-white p-3 rounded shadow-sm" data-id="element-148">
                "No soy buena para los números ni el Excel."
              </li>
              <li className="text-sm text-amber-800 bg-white p-3 rounded shadow-sm" data-id="element-149">
                "Mi ciudad es pequeña, aquí nadie paga precios altos."
              </li>
              <li className="text-sm text-amber-800 bg-white p-3 rounded shadow-sm" data-id="element-150">
                "Ya compré recetarios antes y no me sirvieron para vender más."
              </li>
            </ul>
          </div>

          <div className="bg-green-50 p-6 rounded-xl border border-green-100 md:col-span-2" data-id="element-151">
            <h3 className="font-bold text-green-900 flex items-center gap-2 mb-4" data-id="element-152">
              <HeartIcon className="w-5 h-5 text-green-500" data-id="element-153" /> Ganchos
              Emocionales (Para usar en Copy)
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-154">
              <div className="bg-white p-4 rounded shadow-sm border-l-4 border-green-500" data-id="element-155">
                <span className="text-xs font-bold text-slate-400 uppercase" data-id="element-156">
                  Deseo de Reconocimiento
                </span>
                <p className="text-sm font-medium text-slate-800 mt-1" data-id="element-157">
                  "Demuéstrales que tu pasión sí es un negocio real y rentable."
                </p>
              </div>
              <div className="bg-white p-4 rounded shadow-sm border-l-4 border-green-500" data-id="element-158">
                <span className="text-xs font-bold text-slate-400 uppercase" data-id="element-159">
                  Libertad de Tiempo
                </span>
                <p className="text-sm font-medium text-slate-800 mt-1" data-id="element-160">
                  "Gana más trabajando menos horas, para poder disfrutar a tus
                  hijos."
                </p>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}